
























import Vue from "vue"; 

import LastUpdateModule from "@/store/modules/lastUpdate.module";
import store from "@/store/index";
import { getModule } from "vuex-module-decorators";

const lastUpdateModule = getModule(LastUpdateModule, store);

export default Vue.extend({
  name: "Home",
   mounted() {
    // Reset della data quando si torna alla home
    lastUpdateModule.setLastUpdateDate("");
  },
  data: ()=>({
     
  })
});
